import { render, staticRenderFns } from "./filterInputs.vue?vue&type=template&id=0870af52&scoped=true"
import script from "./filterInputs.vue?vue&type=script&lang=js"
export * from "./filterInputs.vue?vue&type=script&lang=js"
import style0 from "./filterInputs.vue?vue&type=style&index=0&id=0870af52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0870af52",
  null
  
)

export default component.exports